module.exports = __webpack_public_path__ + "img/x-icon.e7820bb0.svg";